import {getArticleById, getRubricById} from "@/shared/services/util";


export const validRubricRoute = (rubrics, query) => {
    if(!Object.prototype.hasOwnProperty.call(query, 'r')) {
        return false;
    }

    let rubricObj = getRubricById(rubrics, query.r);

    return rubricObj != null;
}

export const validArticleRoute = (articles, query, lang) => {
    if(!Object.prototype.hasOwnProperty.call(query, 'r') || !Object.prototype.hasOwnProperty.call(query, 'a')) {
        return false;
    }

    let articleObj = getArticleById(articles, query.r, query.a);
    if(articleObj == null) {
        return false;
    }
    if(!Object.prototype.hasOwnProperty.call(articleObj.content_lang, lang)) {
        return false;
    }
    return !(parseInt(articleObj.content_lang[lang].status) === 0 && !Object.prototype.hasOwnProperty.call(query, 'preview'));
}